export const environment = {
  production: false,
  apiUrl: 'https://api.gbarena.com/api',
  Image: 'https://gbarena-development.s3.amazonaws.com',
  Socket: 'https://socket.gbarena.com',
  iframe: 'https://iframe.gbarena.com',
  Url: 'https://www.gbarena.com/',
  AnUrl: 'https://analytics.gbarena.com/',
  COM_URL: "https://api.community.gbarena.com/",
  endPointWhiteList: ['api.gbarena.com', 'api.notifications.gbarena.com']
};
